// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blind-structures_blindLevelsTableBody__tBur\\+ {
  max-height: 400px;
  overflow-y: auto;

  width: 100%;
  padding: 1rem;
  padding-top: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/tournaments/BlindStructures/blind-structures.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;;EAEhB,WAAW;EACX,aAAa;EACb,cAAc;AAChB","sourcesContent":[".blindLevelsTableBody {\n  max-height: 400px;\n  overflow-y: auto;\n\n  width: 100%;\n  padding: 1rem;\n  padding-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blindLevelsTableBody": `blind-structures_blindLevelsTableBody__tBur+`
};
export default ___CSS_LOADER_EXPORT___;
